import { createTheme } from '@mui/material/styles';
import { colors } from '@src/theme/colors';

import {
  BreakpointSize,
  DEFAULT_FONT_FAMILY,
} from '@constants/common/ui.constants';

const Theme = createTheme({
  palette: {
    custom: colors,
  },
  typography: {
    htmlFontSize: 14,
    fontSize: 16,
    fontFamily: DEFAULT_FONT_FAMILY,
    // Sky DS heading styles are Inter (legacy "Grenze ..." style names in
    // figma kept the old name but switched the family) — no fontFamily
    // override needed, DEFAULT_FONT_FAMILY = Inter.
    h1: {
      fontWeight: 700,
      fontSize: 48,
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 700,
      fontSize: 40,
      lineHeight: 1.2,
    },
    // 32 per the bound figma variable "Heading/H3/Grenze 32/700"; the swatch
    // sheet label says 24 — stale label (same pattern as Background/Tooltip).
    // Re-verify against rendered sections at Steps 10+ (plan D8).
    h3: {
      fontWeight: 700,
      fontSize: 32,
      lineHeight: 1.2,
    },
    h4: {
      fontWeight: 700,
      fontSize: 18,
      lineHeight: '24px',
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '20px',
    },
    body1: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
    },
    body2: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
    },
    // Sky DS "Body3/Poppins_14/400" — the only non-Inter style (footer copyright).
    body3: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
      fontFamily: 'Poppins, sans-serif',
    },
    overline1: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '24px', // Sky "Overline/Inter 14/400": lh 24 (was 20)
      textDecoration: 'underline',
    },
    caption1: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
    },
    caption2: {
      fontWeight: 600,
      fontSize: 12,
      lineHeight: '16px',
    },
  },
  breakpoints: {
    values: {
      xs: BreakpointSize.Xs,
      sm: BreakpointSize.Sm,
      md: BreakpointSize.Md,
      lg: BreakpointSize.Lg,
      xl: BreakpointSize.Xl,
    },
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xxl: '100px',
  },
  components: {
    MuiTypography: {
      defaultProps: {
        color: 'custom.text.white',
      },
    },
    // Sky DS Checkboxes (figma 21722:32247): checked = Buttons/Primary box
    // with white check; unchecked = SecondaryHover outline.
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colors.buttons.secondaryHover,
          '&.Mui-checked': {
            color: colors.buttons.primary,
          },
        },
      },
    },
  },
});

export default Theme;
